import { render, staticRenderFns } from "./RecommendationCards.vue?vue&type=template&id=720da35c&scoped=true"
import script from "./RecommendationCards.vue?vue&type=script&lang=js"
export * from "./RecommendationCards.vue?vue&type=script&lang=js"
import style0 from "./RecommendationCards.vue?vue&type=style&index=0&id=720da35c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720da35c",
  null
  
)

export default component.exports